import { render, staticRenderFns } from "./supplierQuotations.vue?vue&type=template&id=5c6f70a5&"
import script from "./supplierQuotations.vue?vue&type=script&lang=js&"
export * from "./supplierQuotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports